import gql from 'graphql-tag'

export const CREATE_PRODUCT_PACKAGE_MUTATION = gql`
  mutation createProductPackage($shopId: ID!) {
    createProductPackage(shopId: $shopId) {
      id
    }
  }
`

export const UPDATE_PRODUCT_PACKAGE_MUTATION = gql`
  mutation updateProductPackage($id: ID!, $input: ProductPackageInput!) {
    updateProductPackage(id: $id, input: $input) {
      id
    }
  }
`

export const DELETE_PRODUCT_PACKAGE_MUTATION = gql`
  mutation deleteProductPackage($productPackageId: ID!, $salesChannelId: ID!) {
    deleteProductPackageSalesChannel(
      productPackageId: $productPackageId
      salesChannelId: $salesChannelId
    )
  }
`

export const CREATE_PRODUCT_MUTATION = gql`
  mutation createProduct(
    $shopId: ID!
    $status: ProductStatus!
    $input: ProductCreateInput
  ) {
    createProduct(shopId: $shopId, status: $status, input: $input) {
      id
    }
  }
`

export const UPDATE_PRODUCT_MUTATION = gql`
  mutation updateProduct($id: ID!, $input: ProductInput) {
    updateProduct(id: $id, input: $input) {
      id
    }
  }
`

export const DELETE_PRODUCT_MUTATION = gql`
  mutation deleteProduct($id: ID!) {
    deleteProduct(id: $id)
  }
`

export const CREATE_VARIANT_MUTATION = gql`
  mutation createVariant($shopId: ID!) {
    createVariant(shopId: $shopId) {
      id
    }
  }
`

export const UPDATE_VARIANT_MUTATION = gql`
  mutation updateVariant($id: ID!, $input: VariantInput) {
    updateVariant(id: $id, input: $input) {
      id
      options {
        id
        title {
          id
          text {
            content
          }
        }
        value
      }
    }
  }
`

export const DELETE_VARIANT_MUTATION = gql`
  mutation deleteVariant($id: ID!) {
    deleteVariant(id: $id)
  }
`

export const CREATE_PRODUCT_VARIANT_MUTATION = gql`
  mutation createProductVariant(
    $productId: ID!
    $variantId: ID!
    $input: ProductVariantInput
  ) {
    createProductVariant(
      productId: $productId
      variantId: $variantId
      input: $input
    ) {
      id
    }
  }
`

export const UPDATE_PRODUCT_VARIANT_MUTATION = gql`
  mutation updateProductVariant(
    $productId: ID!
    $variantId: ID!
    $input: ProductVariantInput
  ) {
    updateProductVariant(
      productId: $productId
      variantId: $variantId
      input: $input
    ) {
      id
    }
  }
`

export const DELETE_PRODUCT_VARIANT_MUTATION = gql`
  mutation deleteProductVariant($productId: ID!, $variantId: ID!) {
    deleteProductVariant(productId: $productId, variantId: $variantId)
  }
`

export const CREATE_CART_ITEMS_MUTATION = gql`
  mutation createCartItems($input: [CartItemCreateInput]!) {
    createCartItems(input: $input) {
      id
    }
  }
`

export const EMPTY_CART_MUTATION = gql`
  mutation emptyCart($cartId: ID!) {
    emptyCart(cartId: $cartId)
  }
`
